module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight_1.f036b72d.eot";